import { SellerWithAgencyFragment } from '@gql'
import { useStoreState } from '@store/hooks'

export default function useCurrentSeller():
  | SellerWithAgencyFragment
  | undefined {
  return useStoreState((state) => state.seller.current)
}
